import React from 'react';
import './FeaturesSection.css';

interface Feature {
  icon: string;
  title: string;
  description: string;
}

const features: Feature[] = [
  // Phase 2: Easy Appointment Booking — lab scheduling feature hidden for Phase 1
  // {
  //   icon: '\uD83D\uDCC5',
  //   title: 'Easy Appointment Booking',
  //   description: 'Book lab tests at your preferred time and location. Choose from 500+ partner labs near you.',
  // },
  {
    icon: '\uD83D\uDCF7',
    title: 'Smart Document Scanning',
    description: 'Instantly scan or upload your medical reports. AI-powered OCR extracts every metric accurately from photos or PDF files.',
  },
  {
    icon: '\uD83D\uDCCA',
    title: 'Digital Health Reports',
    description: 'Access all your lab reports digitally. Get instant notifications when results are ready.',
  },
  {
    icon: '\uD83D\uDC99',
    title: 'Health Score Tracking',
    description: 'Monitor your overall health with our AI-powered health score. Track trends over time.',
  },
  {
    icon: '\uD83C\uDF55',
    title: 'Personalized Diet Plans',
    description: 'Get customized diet charts based on your health profile and lab results.',
  },
  {
    icon: '\uD83D\uDD14',
    title: 'Smart Notifications',
    description: 'Never miss a scheduled test or follow-up. Receive timely reminders and health alerts.',
  },
  {
    icon: '\uD83D\uDD12',
    title: 'Secure & Private',
    description: 'Your health data is encrypted and stored securely. HIPAA-compliant data handling.',
  },
];

const FeaturesSection: React.FC = () => {
  return (
    <section id="features" className="features">
      <div className="container">
        <h2 className="section-title">Everything You Need for Better Health</h2>
        <p className="section-subtitle">
          A comprehensive platform that puts you in control of your health journey.
        </p>

        <div className="features__grid">
          {features.map((feature, index) => (
            <div key={index} className="features__card">
              <div className="features__icon">
                {feature.icon}
              </div>
              <h3 className="features__card-title">{feature.title}</h3>
              <p className="features__card-desc">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
